import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Routing from "./Routing";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Redux/store";

function App() {
  return (
    <>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
            <Routing />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </>
  );
}

export default App;
